import ExtendedFilter from '@shared/components/filters/extended-filter/extended-filter.vue';
import StdFilter from '@shared/components/filters/std-filter/std-filter';
import EntityFormProvider from '@shared/components/forms/auto-form/entity-form-provider/entity-form-provider.vue';
import StdForm from '@shared/components/forms/auto-form/std-form/std-form.vue';
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import ConfirmationModal from '@shared/components/modals/confirmation-modal/confirmation-modal.vue';
import EntityDeleteModalProvider from '@shared/components/modals/entity-delete-modal-provider/entity-delete-modal-provider.vue';
import { ConfirmationModalConfig } from '@shared/interfaces/confirmation-modal-config';
import { setProp } from '@shared/helpers/operators';
@Component({
  name: 'bpc-post-form',
  components: {
    'bpc-std-form': StdForm,
    'bpc-extended-filter': ExtendedFilter,
    'bpc-entity-delete-modal-provider': EntityDeleteModalProvider,
    'bpc-confirmation-modal': ConfirmationModal,
  },
})
export default class PostForm extends Vue {
  $refs: {
    // resourceForm: InstanceType<typeof ResourceForm> & { saveEntity(): void };
    stdForm: InstanceType<typeof StdForm> & {
      saveEntity(): void;
      formModel: any;
      searchEntity(): void;
      extraData: string | AnyEntity;
      formProvider: EntityFormProvider;
    };
    extendedFilter: InstanceType<typeof StdFilter> & {
      setFilterModel(filterModel): void;
      filterModel: AnyEntity;
    };
    deleteMediaFileConfirmationModal: InstanceType<typeof ConfirmationModal> & {
      onOpenModal(id): void;
      onCloseModal(): void;
    };
  };
  @Prop(String) readonly entity: string;
  @Prop([String, Number]) readonly entityId: string | number;
  @Prop([Object]) readonly value: AnyEntity;
  @Prop({ type: String, default: 'default' }) formConfigName: string;
  @Prop({ type: Boolean, default: true }) readonly disabled: boolean;

  public formModel: AnyEntity = {};

  onFormSaved(e) {
    this.$emit('entity-saved', e);
  }
  onSavingEntity(event) {
    this.$emit('saving-entity', event);
  }
  deleteMediaFile(mediaId) {
    this.$emit('delete-media-file', { mediaId: mediaId, entityId: this.entityId });
  }
  saveEntity() {
    const filterModel = this.$refs.extendedFilter?.filterModel;

    let newModel = {
      ...this.$refs.stdForm.formModel,
    };
    if (filterModel) {
      newModel = {
        ...this.$refs.stdForm.formModel,
        filters: filterModel,
      };
    }
    console.log('newModel', newModel);
    this.$refs.stdForm.formModel = newModel;
    this.$refs.stdForm.saveEntity();
  }

  get postType() {
    return this.formModel?.type;
  }

  @Watch('formModel', { immediate: true, deep: true })
  onFormModelChange() {
    this.$emit('input', this.formModel);
  }

  @Watch('postType')
  onPostTypeChange(val) {
    switch (val) {
      case 'online_training':
      case 'single_activity':
        this.removeRelatedResource();
        this.removeRelatedDiscipline();
        break;
      case 'single_resource':
        this.removeRelatedDiscipline();
        this.removeRelatedActivity();
        break;
      case 'single_discipline':
        this.removeRelatedActivity();
        this.removeRelatedResource();
        break;
      default:
        this.removeRelatedActivity();
        this.removeRelatedResource();
        this.removeRelatedDiscipline();
    }
  }

  removeRelatedActivity() {
    setProp(this.formModel, 'activity', null);
    setProp(this.formModel, 'activity_id', null);
  }

  removeRelatedResource() {
    setProp(this.formModel, 'resource', null);
    setProp(this.formModel, 'resource_id', null);
  }

  removeRelatedDiscipline() {
    setProp(this.formModel, 'discipline', null);
    setProp(this.formModel, 'discipline_id', null);
  }

  get filterEntityType() {
    if (this.formModel.type) {
      if (this.formModel.type === 'archive_of_activities') {
        return 'bpc_activity';
      }
      if (this.formModel.type.includes('archive_of')) {
        return this.formModel.type.replace('archive_of_', '');
      }
      return this.formModel.type;
    }
    return null;
  }

  onConfigLoaded() {
    setTimeout(() => {
      this.$refs.extendedFilter.filterModel = this.$refs.stdForm.formModel.custom_filter.filters;
    });
  }

  isArchive() {
    return this.formModel.type.includes('archive_of');
  }

  getDeleteMediaFileConfirmationModalConfig(): ConfirmationModalConfig {
    return {
      id: 'media-file-delete-modal',
      title: this.$t('global.modals.media-delete.title') as string,
      body: this.$t('global.modals.media-delete.body') as string,
      cancelText: this.$t('global.buttons.cancel') as string,
      acceptText: this.$t('global.buttons.permanent_delete') as string,
      acceptButtonVariant: 'danger',
    };
  }

  onSuccessMediaFileDelete() {
    this.$refs.deleteMediaFileConfirmationModal.onCloseModal();
  }

  showDeleteMediaFileModal(mediaId: string) {
    this.$refs.deleteMediaFileConfirmationModal.onOpenModal(mediaId);
  }
}
